// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d4bbd45a","239":"5c08c1da","453":"21e9e00e","455":"f2bd47d1"}[chunkId] + ".chunk.js";
};